




































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { typesArr, types2Arr } from '@/data/types';
import { fetchUnifiedLocations } from '@/utils/filters';
import { getCustomersPrescriber, getCustomerPrescriber, postOptionPrescriber, deleteDenouncePrescriberById, getDenouncePrescriberStats } from '@/api/api';
import { BACKEND_URL } from '@/helpers/constants';
import { buildDocumentUrl } from '@/helpers/document';
import departments from '@/data/departments';
import LocationFilterComponent from '@/components/LocationFilterComponent.vue';
import Secret from '@/components/common/Secret.vue';
import DenounceReportModal from '@/components/prescriber/DenounceReportModal.vue';
import get from 'lodash/get';

@Component({
    components: { LocationFilterComponent, Secret, DenounceReportModal },
    filters: {
        formatDenouceStatus(status: string) {
            const map: Record<string, string> = {
                accepted: 'Acceptée',
                pending: 'En attente',
                refused: 'Refusée',
            };
            return map[status] || status;
        },
        formatLotStatus(status: string) {
            const map: Record<string, string> = {
                available: 'Libre',
                optionned: 'Optionné',
                reserved: 'Réservé',
                booked:   'Réservé',
                acted:    'Acté',
                retired:  'Retiré de la vente',
                sold:     'Vendu',
            };
            return map[status] || status;
        },
        formatPrice(value: number) {
            if (!value) return '—';
            return value.toLocaleString('fr-FR');
        },
    },
})
export default class DenouncesPrescriber extends Vue {
    searchQuery: string = '';
    statusFilter: string = '';
    localPrivateMode: boolean = false;

    // Country / location filters
    selectedCountry: string = '';
    selectedLocations: any[] = [];
    locationDetailsCache: any[] = [];
    filterRegions: string[] = [];
    filterDepartements: string[] = [];
    filterCities: string[] = [];
    filterCps: string[] = [];

    // Lot filters
    budgetMin: number | null = null;
    budgetMax: number | null = null;
    surfaceMin: number | null = null;
    surfaceMax: number | null = null;
    selectedTypes: string[] = [];
    selectedRooms: string[] = [];
    selectedFloors: string[] = [];
    sortBy: string = 'price_asc';

    denounces: any[] = [];
    failedCustomers: Array<{ id: number }> = [];
    loading: boolean = false;
    loadError: string | null = null;

    allCustomers: any[] = [];
    loadedCustomerIndex: number = 0;
    loadingMore: boolean = false;
    batchSize: number = 5;

    totalDenounces: number = 0;
    totalAccepted: number = 0;

    showInfoPopup: boolean = false;
    selectedDenounce: any = null;
    denounceToDelete: any = null;
    showDeleteDenouncePopup: boolean = false;
    deletingDenounce: boolean = false;

    selectedDenounceIds: number[] = [];
    showDenounceReportModal: boolean = false;

    async mounted() {
        this.initializeUserColor();
        await Promise.all([this.loadDenounces(), this.fetchStats()]);
    }

    async fetchStats() {
        try {
            const { data } = await getDenouncePrescriberStats();
            this.totalDenounces = data.total;
            this.totalAccepted = data.accepted;
        } catch {
            // fallback: counts will stay 0 until denounces are loaded
        }
    }

    async loadDenounces() {
        this.loading = true;
        this.loadError = null;
        this.failedCustomers = [];
        this.denounces = [];
        this.loadedCustomerIndex = 0;
        try {
            const { data: customerList } = await getCustomersPrescriber(null);
            this.allCustomers = Array.isArray(customerList) ? customerList : (customerList as any).data || [];
            await this.loadNextBatch();
        } catch {
            this.loadError = 'Impossible de charger les dénonces.';
        } finally {
            this.loading = false;
        }
    }

    async loadNextBatch() {
        const start = this.loadedCustomerIndex;
        const end = Math.min(start + this.batchSize, this.allCustomers.length);
        const batch = this.allCustomers.slice(start, end);
        if (batch.length === 0) return;

        this.loadingMore = true;
        try {
            const results = await Promise.all(
                batch.map((c: any) =>
                    getCustomerPrescriber(c.id)
                        .then((r: any) => ({ ok: true as true, data: r.data }))
                        .catch(() => ({ ok: false as false, id: c.id }))
                )
            );

            const fullCustomers: any[] = [];
            results.forEach((result: any) => {
                if (result.ok) {
                    fullCustomers.push(result.data);
                } else {
                    this.failedCustomers.push({ id: result.id });
                }
            });

            const newDenounces = this.mapCustomersToDenounces(fullCustomers);
            this.denounces = [...this.denounces, ...newDenounces]
                .sort((a, b) => b.createdAtRaw - a.createdAtRaw);
            this.loadedCustomerIndex = end;
        } finally {
            this.loadingMore = false;
        }
    }



    private mapCustomersToDenounces(customers: any[]): any[] {
    const result: any[] = [];

    for (const customer of customers) {
        if (!customer.denounces || !customer.denounces.length) continue;

        const customerName = `${customer.first_firstname || ''} ${customer.first_lastname || ''}`.trim();
        const optionMap = new Map();
        if (customer.options) {
            customer.options.forEach((o: any) => {
                if (o.lot) {
                    optionMap.set(o.lot.id, o.status);
                }
            });
        }
        const bookingLotIds: number[] = (customer.bookings || [])
            .map((b: any) => b.lot ? b.lot.id : null)
            .filter(Boolean);

        for (const d of customer.denounces) {
            const program = d.program || {};
            const addr = program.address || {};
            const city: string = addr.city || '';
            const postalCode: string = addr.postal_code || '';
            const departmentCode: string = postalCode.substring(0, 2);
            const dept = departments.find((dep: any) => dep.code === departmentCode);

            result.push({
                id: d.id,
                customer: customerName,
                programId: program.id,
                programName: program.name,
                address: [addr.street, postalCode, city].filter(Boolean).join(' '),
                country: 'FR',
                city,
                postalCode,
                departmentCode,
                regionCode: dept ? dept.region_code : '',
                promoter: program.promoter ? program.promoter.id : null,
                promoterName: program.promoter ? program.promoter.name : null,
                delivery: program.date_delivery ? this.formatDate(program.date_delivery) : null,
                status: d.status,
                createdAtRaw: d.created_at ? new Date(d.created_at).getTime() : 0,
                updatedAt: d.updated_at ? this.formatDate(d.updated_at) : null,
                project: d.project,
                tauxCommission: d.taux_commission,
                lots: (d.lots || []).map((lot: any) => ({
                    id: lot.id,
                    name: lot.name,
                    type: lot.type,
                    type2: lot.type2,
                    floor: lot.floor,
                    exposure: lot.exposure,
                    surface: lot.surface_carrez,
                    terrace: lot.surface_terrace,
                    varangue: lot.surface_terrace_varangue,
                    garden: lot.surface_copro_garden,
                    parking1: lot.name_parking1,
                    parking2: lot.name_parking2,
                    status: lot.status,
                    optionStatus: optionMap.has(lot.id) ? optionMap.get(lot.id) : null,
                    bookingStatus: bookingLotIds.includes(lot.id) ? 'booked' : null,
                    honoRate: program.duty_free_fee || null,
                    price: lot.price,
                    updatedAt: lot.updated_at ? this.formatDate(lot.updated_at) : null,
                    plan: lot.plan
                        ? buildDocumentUrl(BACKEND_URL, lot.plan)
                        : null,
                })),
            });
        }
    }

    return result;
}


    private formatDate(raw: string): string {
        if (!raw) return '';
        const d = new Date(raw);
        if (isNaN(d.getTime())) return raw;
        return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }

    getCommissionDisplay(tauxCommission: any): string {
        if (tauxCommission === null || tauxCommission === undefined || tauxCommission === '') {
            return 'NC';
        }

        const value = Number(tauxCommission);
        if (isNaN(value)) {
            return 'NC';
        }

        return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })}%`;
    }

    get acceptedCount() {
        return this.denounces.filter(d => d.status === 'accepted').length;
    }

    get allLots(): any[] {
        return this.denounces.flatMap(d => d.lots);
    }

    get statsDisponibles() {
        return this.allLots.filter(l => l.status === 'available').length;
    }

    get statsOptionnes() {
        return this.allLots.filter(l => l.status === 'optionned' || l.optionStatus).length;
    }

    get statsReserves() {
        return this.allLots.filter(l => l.status === 'reserved').length;
    }

    get propertyTypes() {
        const existing = new Set(this.allLots.map((l: any) => l.type).filter(Boolean));
        return typesArr.filter(t => existing.has(t.value));
    }

    get roomOptions() {
        const existing = new Set(this.allLots.map((l: any) => l.type2).filter(Boolean));
        return types2Arr.filter(t => existing.has(t.value));
    }

    get floorOptions() {
        const existing = [...new Set(this.allLots.map((l: any) => String(l.floor)).filter(Boolean))];
        return existing
            .sort((a, b) => {
                if (a === 'RDC' || a === 'RDJ') return -1;
                if (b === 'RDC' || b === 'RDJ') return 1;
                const aNum = parseInt(a);
                const bNum = parseInt(b);
                if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;
                return a.localeCompare(b);
            })
            .map(f => ({ text: f, value: f }));
    }

    get sortOptions() {
        return [
            { text: 'Prix Croissant',              value: 'price_asc' },
            { text: 'Prix Décroissant',             value: 'price_desc' },
            { text: 'Surface Croissante',           value: 'surface_asc' },
            { text: 'Surface Décroissante',         value: 'surface_desc' },
        ];
    }

    get fetchUnifiedLocations() {
        return fetchUnifiedLocations;
    }

    onUnifiedLocationChange(values: any[]) {
        if (!values || values.length === 0) {
            this.filterRegions = [];
            this.filterDepartements = [];
            this.filterCities = [];
            this.filterCps = [];
            this.selectedLocations = [];
            this.locationDetailsCache = [];
            return;
        }

        this.locationDetailsCache = values;

        const regions: string[] = [];
        const departements: string[] = [];
        const cities: string[] = [];
        const cps: string[] = [];

        values.forEach((location: any) => {
            if (location.type === 'Region') {
                regions.push(location.value);
            } else if (location.type === 'Departement') {
                departements.push(location.value);
            } else if (location.type === 'Ville') {
                cities.push(location.value);
                if (location.postalCode) {
                    cps.push(location.postalCode);
                }
            } else if (location.type === 'Code postal') {
                cps.push(location.value);
            }
        });

        this.filterRegions = regions;
        this.filterDepartements = [...new Set(departements)];
        this.filterCities = cities;
        this.filterCps = [...new Set(cps)];
        this.selectedLocations = values.map((v: any) => v.value);
    }

    removeLocation(index: number) {
        this.locationDetailsCache.splice(index, 1);
        this.selectedLocations = this.locationDetailsCache.map((v: any) => v.value);
        this.onUnifiedLocationChange(this.locationDetailsCache);
    }

    getLocationTypeClass(type: string): string {
        const typeMap: any = { 'Region': 'type-region', 'Departement': 'type-departement', 'Ville': 'type-ville', 'Code postal': 'type-postal' };
        return typeMap[type] || '';
    }

    getLocationTypeIcon(type: string): string {
        const iconMap: any = { 'Region': '🌍', 'Departement': '📍', 'Ville': '🏙️', 'Code postal': '📮' };
        return iconMap[type] || '📌';
    }

    matchesLocationFilter(d: any): boolean {
        // Country filter
        if (this.selectedCountry !== '' && d.country !== this.selectedCountry) return false;

        // Location filter (only relevant for France)
        if (this.selectedCountry === 'FR') {
            const hasRegions = this.filterRegions.length > 0;
            const hasDepts = this.filterDepartements.length > 0;
            const hasCities = this.filterCities.length > 0;
            const hasCps = this.filterCps.length > 0;

            if (hasRegions || hasDepts || hasCities || hasCps) {
                const inRegion = hasRegions && this.filterRegions.includes(d.regionCode);
                const inDept = hasDepts && this.filterDepartements.includes(d.departmentCode);
                const inCity = hasCities && this.filterCities.some((c: string) =>
                    d.city && d.city.toLowerCase().includes(c.toLowerCase())
                );
                const inCp = hasCps && this.filterCps.some((cp: string) =>
                    d.postalCode && d.postalCode.startsWith(cp)
                );
                if (!inRegion && !inDept && !inCity && !inCp) return false;
            }
        }

        return true;
    }

    get filteredDenounes() {
        return this.denounces.filter(d => {
            const matchSearch = !this.searchQuery ||
                d.customer.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                String(d.programId).includes(this.searchQuery) ||
                (d.programName && d.programName.toLowerCase().includes(this.searchQuery.toLowerCase()));
            const matchStatus = !this.statusFilter || d.status === this.statusFilter;
            return matchSearch && matchStatus && this.matchesLocationFilter(d);
        });
    }

    matchesLotFilters(lot: any): boolean {
        if (this.budgetMin !== null && lot.price < this.budgetMin) return false;
        if (this.budgetMax !== null && lot.price > this.budgetMax) return false;
        if (this.surfaceMin !== null && lot.surface < this.surfaceMin) return false;
        if (this.surfaceMax !== null && lot.surface > this.surfaceMax) return false;
        if (this.selectedTypes.length > 0 && lot.type && !this.selectedTypes.includes(lot.type)) return false;
        if (this.selectedRooms.length > 0 && !this.selectedRooms.includes(lot.type2)) return false;
        if (this.selectedFloors.length > 0 && !this.selectedFloors.includes(String(lot.floor))) return false;
        return true;
    }

    get tableRows(): any[] {
        return this.filteredDenounes.flatMap(denounce => {
            let lots = denounce.lots.filter((lot: any) => this.matchesLotFilters(lot));

            switch (this.sortBy) {
                case 'price_asc':  lots = lots.slice().sort((a: any, b: any) => a.price - b.price); break;
                case 'price_desc': lots = lots.slice().sort((a: any, b: any) => b.price - a.price); break;
                case 'surface_asc':  lots = lots.slice().sort((a: any, b: any) => a.surface - b.surface); break;
                case 'surface_desc': lots = lots.slice().sort((a: any, b: any) => b.surface - a.surface); break;
            }

            if (lots.length === 0) return [];

            return [
                { type: 'denounce', denounce, key: `d-${denounce.id}` },
                ...lots.map((lot: any) => ({
                    type: 'lot',
                    denounce,
                    lot,
                    key: `l-${denounce.id}-${lot.id}`,
                })),
            ];
        });
    }

    toggleLocalPrivateMode() {
        this.localPrivateMode = !this.localPrivateMode;
    }

    toggleType(value: string) {
        const i = this.selectedTypes.indexOf(value);
        if (i > -1) this.selectedTypes.splice(i, 1);
        else this.selectedTypes.push(value);
    }

    toggleRoom(value: string) {
        const i = this.selectedRooms.indexOf(value);
        if (i > -1) this.selectedRooms.splice(i, 1);
        else this.selectedRooms.push(value);
    }

    toggleFloor(value: string) {
        const i = this.selectedFloors.indexOf(value);
        if (i > -1) this.selectedFloors.splice(i, 1);
        else this.selectedFloors.push(value);
    }

    resetFilters() {
        this.selectedCountry = '';
        this.selectedLocations = [];
        this.locationDetailsCache = [];
        this.filterRegions = [];
        this.filterDepartements = [];
        this.filterCities = [];
        this.filterCps = [];
        this.budgetMin = null;
        this.budgetMax = null;
        this.surfaceMin = null;
        this.surfaceMax = null;
        this.selectedTypes = [];
        this.selectedRooms = [];
        this.selectedFloors = [];
        this.sortBy = 'price_asc';
    }

    setPrimaryColor(hexColor: string): void {
        const r = parseInt(hexColor.slice(1, 3), 16);
        const g = parseInt(hexColor.slice(3, 5), 16);
        const b = parseInt(hexColor.slice(5, 7), 16);
        document.documentElement.style.setProperty('--primary-color', hexColor);
        document.documentElement.style.setProperty('--vs-primary', `${r}, ${g}, ${b}`);
        document.documentElement.style.setProperty('--vs-personal_color', `${r}, ${g}, ${b}`);
    }

    getUserPrimaryColor(): string {
        const authJson = localStorage.getItem('auth');
        if (authJson) {
            try {
                const auth = JSON.parse(authJson);
                return auth.personal_color || '#ff5733';
            } catch {
                return '#ff5733';
            }
        }
        return '#ff5733';
    }

    initializeUserColor(): void {
        this.setPrimaryColor(this.getUserPrimaryColor());
    }


    async postOption(lot: any, denounce: any) {
    const $vs = (this as any).$vs;
    if (!lot.id || !denounce.id) return;
    try {
        await postOptionPrescriber(lot.id, denounce.id);
        lot.optionStatus = 'pending';
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Modification',
            text: `L'option a bien ete posee`,
        });
    } catch (error) {
        const message = get(error, 'response.data.errors.children.lot.errors[0]', 'Une erreur est survenue');
        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: message,
        });
    }
}


    standardizedSecret(value: any) {
        return {
            length: 5,
            originalValue: value,
            toString() { return this.originalValue; }
        };
    }

    honoFormat(hono: number, price: number) {
        const actualValue = Math.round(price * (hono / 100)) + ' € HT/TTC soit ' + hono + '%HT/TTC';
        return this.standardizedSecret(actualValue);
    }

    isDenounceSelected(id: number): boolean {
        return this.selectedDenounceIds.includes(id);
    }

    toggleDenounceSelection(id: number) {
        const idx = this.selectedDenounceIds.indexOf(id);
        if (idx > -1) {
            this.selectedDenounceIds.splice(idx, 1);
        } else {
            this.selectedDenounceIds.push(id);
        }
    }

    get selectedDenounces(): any[] {
        return this.denounces.filter(d => this.selectedDenounceIds.includes(d.id));
    }

    get allVisibleDenounceIds(): number[] {
        return [...new Set(this.tableRows
            .filter(r => r.type === 'denounce')
            .map(r => r.denounce.id))];
    }

    toggleAllDenounces(event: Event) {
        const checked = (event.target as HTMLInputElement).checked;
        if (checked) {
            this.allVisibleDenounceIds.forEach(id => {
                if (!this.selectedDenounceIds.includes(id)) {
                    this.selectedDenounceIds.push(id);
                }
            });
        } else {
            this.allVisibleDenounceIds.forEach(id => {
                const idx = this.selectedDenounceIds.indexOf(id);
                if (idx > -1) this.selectedDenounceIds.splice(idx, 1);
            });
        }
    }

    canDeleteDenounce(denounce: any): boolean {
        if (denounce.status !== 'pending' && denounce.status !== 'refused') return false;
        if (!denounce.lots || denounce.lots.length === 0) return false;
        for (const lot of denounce.lots) {
            if (lot.optionStatus) return false;
            if (lot.bookingStatus) return false;
        }
        return true;
    }

    deleteDenounce(denounce: any) {
        this.denounceToDelete = denounce;
        this.showDeleteDenouncePopup = true;
    }

    async confirmDeleteDenounce() {
        if (!this.denounceToDelete) return;
        const denounce = this.denounceToDelete;
        this.deletingDenounce = true;
        const $vs = (this as any).$vs;
        try {
            await deleteDenouncePrescriberById(denounce.id);
            const index = this.denounces.indexOf(denounce);
            if (index !== -1) this.denounces.splice(index, 1);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Succes',
                text: 'La denonce a bien ete supprimee',
            });
        } catch (error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Une erreur est survenue lors de la suppression',
            });
        } finally {
            this.deletingDenounce = false;
            this.showDeleteDenouncePopup = false;
            this.denounceToDelete = null;
        }
    }
}
